import PropTypes from 'prop-types';
import React from 'react';

import { StyledDefaultTemplateLeftColumnButton } from './styles';

const DefaultTemplateLeftColumnButton = ({
  active,
  onClick,
  className,
  isLogoutButton,
  title,
  icon: IconComponent,
}) => (
  <StyledDefaultTemplateLeftColumnButton
    active={active}
    className={className}
    data-test-id="0afac6e6-465e-4cf7-99fe-56693576a36d"
    isLogoutButton={isLogoutButton}
    onClick={onClick}
    variant="empty"
  >
    {IconComponent && <IconComponent />}
    {title}
  </StyledDefaultTemplateLeftColumnButton>
);

DefaultTemplateLeftColumnButton.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.elementType]).isRequired,
  isLogoutButton: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

DefaultTemplateLeftColumnButton.defaultProps = {
  active: false,
  className: '',
  isLogoutButton: false,
};

export default DefaultTemplateLeftColumnButton;
